<template>
    <div class="containers-fluid portal">
        <div class="cover-text">
            <div class="title m-b-md mincho">
                貸し本棚
                <div class="sub-title">
                    専用の本棚、お貸しします。
                </div>
            </div>

            <div class="links d-none d-lg-block f-white bg-blur">
                <router-link to="/about">貸し本棚とは</router-link>
                <a href="/register" v-if="!isLoggedIn">ユーザー登録</a>
                <a href="/login" v-if="!isLoggedIn">ログイン</a>
                <a href="/guest" v-if="!isLoggedIn">
                    <i class="fas fa-vial"></i>
                    お試し登録
                </a>
                <router-link to="/mypage" v-if="isLoggedIn">マイページ</router-link>
                <router-link to="/novels/news" v-if="isLoggedIn">小説一覧</router-link>
                <router-link to="/notices">お知らせ</router-link>
                <router-link to="/contact">お問い合わせ</router-link>
                <router-link to="/help">ヘルプ</router-link>
            </div>
        </div>
        <div class="bg" :style="'background-image: url('+bg.url+')'" v-if="bg.id">
            <div class="copyright" v-html="bg.license" v-if="bg.license"></div>
        </div>
        <div class="container" v-show="show">
            <div class="slider-block eyecatch-block">
                <slider :novels="long"
                    caption="長編おすすめ"
                    link="/novels/long"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
            <div class="slider-block">
                <slider :novels="short"
                    caption="短編おすすめ"
                    childClass="mt-5"
                    link="/novels/short"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
            <div class="row menu-block">
                <div class="col-lg-7 mt-5">
                    <listbox :novels="finishes"
                        caption="完結・電子書籍"
                        link="/novels/finishes"
                        :has-desc="true"
                        @showNovel="showNovel($event)"></listbox>
                </div>
                <div class="col-lg-5 mt-5">
                    <salvage :novels="salvage"
                        caption="過去の掲載作品"
                        link="/novels/finishes"
                        @showNovel="showNovel($event)"></salvage>
                    <menus></menus>
                    <div class="board">
                        <img src="/img/top/katoh.jpg" class="person">
                        <div class="board-text b-air">
                            <router-link to="/product" class="black">
                                「貸し本棚」は４周年を迎えました。
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="slider-block">
                <slider :novels="updates"
                    caption="更新"
                    childClass="mt-5"
                    link="/novels/updates"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
            <div class="slider-block">
                <authors :authors="authors"></authors>
            </div>
            <div class="slider-block">
                <slider :novels="news"
                    caption="新着"
                    childClass="mt-5"
                    link="/novels/news"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
            <div class="slider-block" v-if="r18">
                <slider :novels="r18"
                    caption="R18"
                    childClass="mt-5"
                    link="/novels/r18"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
            <div class="slider-block" v-if="xxx">
                <slider :novels="xxx"
                    caption="XXX"
                    childClass="mt-5"
                    link="/novels/xxx"
                    :has-desc="true"
                    @showNovel="showNovel($event)"></slider>
            </div>
        </div>
        <novel :book="book"></novel>
    </div>
</template>

<style scoped lang="scss">
.bg {
    background-repeat: no-repeat;
    background-position: top, left, center, center;
    background-size: cover;
    background-color: #000;
    background-attachment: fixed;
    width: 100%;
    min-height: 400px;
    max-height: 500px;
	-webkit-transition: 2.5s ease-in-out;
	transition: 2.5s ease-in-out;
}
.portal {
    position:relative;
    display:block;
    margin:0;
    padding:0;
}

.caption {
    background-color: #555;
    color: #eee;
    font-size: 1.1rem;
    padding: 0.5rem 1rem;
    margin-top: 0.5rem;
    border-radius: .5rem .5rem 0 0;
    &.blue {
        background-color: #171757;
    }
    &.red {
        background-color: #682121;
    }
    &.black {
        background-color: black;
    }
}

.cover-text {
    position:absolute;
    top:50px;
    left:0px;
    z-index:2;
    text-align:center;
    width:100%;
    color: snow;
    font-size:16px;
    letter-spacing: 2px;
    text-shadow: 0 0 7px #fff;
    p {
        margin: 1em auto;
        max-width: 860px;
        text-shadow: 0 0 5px #fff;
        font-size: .8rem;
    }
    .title {
        font-size: 84px;
        z-index: 10;
        .sub-title {
            font-size: .9rem;
        }
    }
}
.links {
    background-color: rgba(0, 0, 0, .4);
    a {
        color: snow;
        padding: 0 25px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: .1rem;
        text-decoration: none;
        text-transform: uppercase;
        text-shadow: none;
        &:hover {
            text-shadow: 0 0 12px rgba(255, 255, 255, .8);
        }
    }
}
.m-b-md {
    margin-bottom: 4rem;
}
.eyecatch-block {
    margin-top: -5rem;
}
.board {
    margin-top: 3rem;
    padding: 0 1rem;
    .person {
        object-fit: cover;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        border: 1px solid #ddd;
        background-color: white;
        padding: 3px;
        margin: 0 0 -1rem .5rem;
    }
    .board-text {
        padding: 1.5rem 1rem 1rem;
        border: 1px solid #ddd;
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: .5rem;
    }
}
.copyright {
    position: absolute;
    right: .2rem;
    top: .2rem
}
@media (min-width: 1280px) {
    .container {
        max-width: 1500px;
    }
}
@media (max-width: 1024px) {
    .bg {
        background-size: 150% auto;
    }
}
@media screen and (max-width: 575px) {
    .container {
        padding: 0 5px;
    }
    .menu-block {
        margin: 0;
        div {
            padding: 0;
            width: calc(100vw - 10px);
        }
    }
    .eyecatch-block {
        margin-top: -7rem;
    }
}
</style>

<script>
import slider from "./slider";
import listbox from "./listbox";
import menus from "./menus";
import authors from "./authors";
import novel from "./novel";
import salvage from "./salvage";
export default {
    components: {
        slider,
        listbox,
        menus,
        authors,
        novel,
        salvage
    },
    data() {
        return {
            long: {},
            short: {},
            news: {},
            updates: {},
            finishes: {},
            r18: {},
            xxx: {},
            salvage: {},
            authors: {},
            keywords: "",
            show: false,
            book_id: null,
            book: null,
            bg: {},
        }
    },
    methods: {
        load() {
            this.show = false;
            axios.get("/portal/equalizer").then(res => {
                this.long = this._uniqid(res.data.long);
                this.short = this._uniqid(res.data.short);
                this.news = this._uniqid(res.data.news);
                this.updates = this._uniqid(res.data.updates);
                this.finishes = this._uniqid(res.data.finishes);
                this.r18 = this._uniqid(res.data.r18);
                this.xxx = this._uniqid(res.data.xxx);
                this.salvage = this._uniqid(res.data.salvage);
                this.show = true;
            }).catch(err => { alert.err(err.response) });
        },
        loadBookshelfs() {
            axios.get("/portal/bookshelfs").then(res => {
                this.authors = res.data;
            }).catch(err => { alert.err(err.response) });;
        },
        _uniqid(list, prefix = "") {
            if (!list) return list;
            for (let o of list) {
                let sec = Date.now() * 1000 + Math.random() * 1000;
                let id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
                o.uid = `${prefix}${id}${Math.trunc(Math.random() * 100000000)}`;
            }
            return list;
        },
        refreshBg() {
            axios.get("/picture/top", {params: {id: this.bg.id || null}}).then(res => {
                if (this.bg.id !== res.data.id) {
                    this.bg = res.data;
                }
            }).catch(err => { alert.err(err.response) });
            setTimeout(this.refreshBg, 60000);
        },
        showNovel(book) {
            this.book = book;
            setTimeout(() => {
                $("#novel-description").modal();
            });
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.state.user?.id;
        },
    },
    mounted() {
        this.load();
        this.loadBookshelfs();
        this.refreshBg();
        setTimeout(() => {
            this.useHead({
                title: "貸し本棚 | Web小説家の隠れ家・小説投稿サイト",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>